// ─── Feature: Custom Mega Menu — updated 2026-04-06 ───────────────────────

// Initialize features that are normally called by HeaderSection
// (requires [data-section-type="header"] — if that's hidden, they never run)
(function () {
  if (typeof theme === 'undefined') return;

  var originalHeader = document.querySelector('[data-section-type="header"]');
  if (originalHeader) return;

  // Announcement bar slider
  if (theme.announcementBar && typeof theme.announcementBar.init === 'function') {
    theme.announcementBar.init();
  }

  // Nav drawer (hamburger mobile menu)
  if (theme.Drawers && document.getElementById('NavDrawer')) {
    theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
    theme.collapsibles.init(document.getElementById('NavDrawer'));
  }

  // Cart drawer
  if (theme.settings && theme.settings.cartType === 'drawer' && theme.CartDrawer) {
    if (!document.body.classList.contains('template-cart')) {
      new theme.CartDrawer();
    }
  }
})();

(function () {
  var items = document.querySelectorAll('.has-cmm-dropdown');
  var overlay = document.getElementById('cmmDropdownOverlay');

  if (!items.length) return;

  function animateOpen(panel, skipAnimation) {
    var target = panel.scrollHeight;

    if (skipAnimation) {
      panel.style.opacity = '1';
      panel.style.height = target + 'px';
      requestAnimationFrame(function () {
        panel.style.height = 'auto';
      });
      return;
    }

    panel.style.opacity = '0';
    panel.style.height = '0px';

    requestAnimationFrame(function () {
      panel.style.opacity = '1';
      panel.style.height = target + 'px';
    });

    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function animateClose(panel) {
    var current = panel.scrollHeight;
    panel.style.height = current + 'px';
    panel.offsetHeight; // force reflow

    requestAnimationFrame(function () {
      panel.style.opacity = '0';
      panel.style.height = '0px';
    });
  }

  function closeOthers(except) {
    items.forEach(function (item) {
      if (item !== except && item.classList.contains('cmm--open')) {
        var p = item.querySelector('.cmm__panel');
        animateClose(p);
        item.classList.remove('cmm--open');
        item.querySelector('.cmm__trigger').setAttribute('aria-expanded', 'false');
      }
    });
  }

  function closeAll() {
    items.forEach(function (item) {
      if (item.classList.contains('cmm--open')) {
        animateClose(item.querySelector('.cmm__panel'));
        item.classList.remove('cmm--open');
        item.querySelector('.cmm__trigger').setAttribute('aria-expanded', 'false');
      }
    });
    if (overlay) overlay.classList.remove('cmm-overlay--active');
  }

  items.forEach(function (item) {
    var btn = item.querySelector('.cmm__trigger');
    var panel = item.querySelector('.cmm__panel');
    if (!btn || !panel) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var skip = false;
      items.forEach(function (other) {
        if (other !== item && other.classList.contains('cmm--open')) {
          skip = true;
        }
      });

      if (item.classList.contains('cmm--open')) {
        animateClose(panel);
        item.classList.remove('cmm--open');
        btn.setAttribute('aria-expanded', 'false');
        if (overlay) overlay.classList.remove('cmm-overlay--active');
      } else {
        closeOthers(item);
        item.classList.add('cmm--open');
        btn.setAttribute('aria-expanded', 'true');
        if (overlay) overlay.classList.add('cmm-overlay--active');
        animateOpen(panel, skip);
      }
    });
  });

  // Close on click outside or on overlay
  document.addEventListener('click', function (e) {
    var inside = e.target.closest('.has-cmm-dropdown');
    var isOverlay = overlay && e.target === overlay;
    var isLink = e.target.closest('.cmm__panel a');

    if (isOverlay || isLink || !inside) {
      closeAll();
    }
  });
})();


// ─── Feature: Subscription Tier Callout Reposition — 2026-04-21 ─────────────
// Moves the '.subscription-tier-callout' element out of the product form and
// places it directly above the Recharge subscription widget so the 1/2/3+ bag
// savings visually connect to the Subscribe box. Kopia-only.
(function () {
  function reposition() {
    var callout = document.querySelector('.subscription-tier-callout');
    var widget  = document.querySelector('.recharge-subscription-widget');
    if (!callout || !widget) return false;
    if (callout.parentElement === widget.parentElement && callout.nextElementSibling === widget) {
      // already in place
      return true;
    }
    // Insert callout as sibling immediately before the Recharge widget
    widget.parentElement.insertBefore(callout, widget);
    callout.classList.add('sc-repositioned');
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reposition);
  } else {
    reposition();
  }

  // Recharge widget renders async — watch for it and reposition if it appears later or re-renders
  var observer = new MutationObserver(function () {
    reposition();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Safety fallback: try a few times over the next few seconds in case the widget is slow
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    if (reposition() || tries > 20) clearInterval(poll);
  }, 250);
})();
